'use strict';

/**
 * @author Henrik Reinbach Madsen
 * @requires flickity.js https://github.com/metafizzy/flickity
 */

var novicell = novicell || {};


novicell.slideshow = novicell.slideshow || new function () {
    const slideshows = document.querySelectorAll('.js-slideshow');

    this.init = function () {
        if (!slideshows) {
            return;
        }
        for (let i = 0; i < slideshows.length; i++) {

            const slideshowElm = slideshows[i];
            const allSlides = slideshowElm.querySelectorAll('.slideshow-slide');
            const slideshowNav = slideshowElm.querySelector('.slideshow__navigation');
            const navTitle = slideshowNav ? slideshowNav.querySelector('.slideshow-slide__title') : null;
            const arrowPlaceholder = slideshowNav ? slideshowNav.querySelector('.js-arrow-placeholder') : null;
            const flkty = new Flickity(slideshowElm, {
                // options
                cellAlign: 'left',
                cellSelector: '.slideshow-slide',
                contain: true,
                wrapAround: true,
                autoPlay: slideshowElm.hasAttribute('data-autoplay') ? parseInt(slideshowElm.getAttribute('data-autoplay')) : false,
                pageDots: slideshowElm.hasAttribute('data-pageDots'),
                arrowShape: {
                    x0: 10,
                    x1: 40,
                    y1: 30,
                    x2: 45,
                    y2: 30,
                    x3: 15
                },
                // arrowShape: 'M71.3,100 21.3,50 71.3,0 78.7,7.5 36.2,50 78.7,92.5 z',
                on: {
                    ready: function () {
                        if (navTitle && allSlides[0].querySelector('.slideshow-slide__title')) {
                            navTitle.textContent = allSlides[0].querySelector('.slideshow-slide__title').textContent;
                        }

                        let arrows = slideshowElm.querySelectorAll('.flickity-prev-next-button');
                        if (arrowPlaceholder) {
                            for (let index = 0, length = arrows.length; index < length; index++) {
                                const arrow = arrows[index];
                                arrowPlaceholder.appendChild(arrow);
                            }
                        }
                    },
                    change: function (index) {
                        if (navTitle) {
                            navTitle.textContent = allSlides[index].querySelector('.slideshow-slide__title').textContent;
                        }
                    }
                }
            });
        }

        // Video overlay
        /* var videoOverlayTriggers = document.querySelectorAll('.js-video-overlay-trigger');

        for (var i = 0; i < videoOverlayTriggers.length; i++) {
            videoOverlayTriggers[i].addEventListener('click', function (e) {
                e.preventDefault();
                var currentTrigger = this;

                novicell.overlay.create({
                    'videoId': currentTrigger.getAttribute('data-video-id'),
                    'type': currentTrigger.getAttribute('data-type'),
                    'class': 'video-overlay',
                    'autoplay': 1
                });
            });
        } */
    };
}();
